import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button,
    Popconfirm, Popover,
} from 'antd';

import { asyncGet, actions } from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import Edit from './edit.js';
import AddAccountValue from './addAccountValue.js';
import { delect, delectAll } from './reducers';

class AppAccount extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    reStart = record => {
        const { scriptId } = record;
        this.props.reStart({ scriptIds: [scriptId], action: '7', executeNow: true });
        this.props.asyncGet();
    }

    edit = record => {
        this.props.editShow();
        this.props.changeCurrentSelectId(record._id);
    }
    addAccountValues = record => {
        this.props.editShowValues();
        this.props.changeCurrentSelectId(record._id);
    }

    handleDelete = async record => {
        record.deleteFlag = '1';
        await this.props.delect(record);
        this.props.asyncGet();
    }

    renderAction = (text, record) => {
        return (
            <div>
                <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => { this.edit(record); }} >
                    编辑
                </Button>
                <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => { this.addAccountValues(record); }} >
                    添加账号
                </Button>
                <Popconfirm title="是否删除?" onConfirm={() => { this.handleDelete(record); }} >
                    <Button type="primary" style={{ marginRight: '5px' }} size="small">
                        < a href="#">删除</a>
                    </Button>
                </Popconfirm>
            </div>
        );
    };

    onSelectChange = (selectedRowKeys, selectedRows) => { //selectedRowKeys  指定选中项的 key 数组
        this.props.getTransferData({ selectedRowKeys });
        this.props.getSele(selectedRowKeys);
    }

    render() {
        let { list, uiStatus, pagination, transferData } = this.props;
        const { selectedRowKeys } = transferData;
        let { isLoading } = uiStatus;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const columns = [
            {
                title: '账号名称',
                dataIndex: 'accountName',
                key: 'accountName',
            },
            {
                title: 'redisKey',
                dataIndex: 'redisKey',
                key: 'redisKey',
            },
            {
                title: '账号列表',
                dataIndex: 'accountValues',
                key: 'accountValues',
                render: (accountValues) => {
                    let content = (
                        <div>
                            {accountValues ? accountValues.map((v) => {
                                return <p>{v}</p>;
                            }) : ''}
                        </div>
                    );
                    return (
                        <div>
                            {accountValues
                                ? accountValues
                                    .filter((item, index) => index < 2)
                                    .map((v) => {
                                        return <p>{v}</p>;
                                    })
                                : ''}
                            {accountValues && accountValues.length > 2 ? (
                                <Popover content={content} title="值列表">
                                    <a type="primary">...</a>
                                </Popover>
                            ) : ('')}
                        </div>
                    );
                },
            },
            {
                title: 'count',
                dataIndex: 'count',
                key: 'count',
            },
            {
                title: '创建时间',
                dataIndex: 'createTime',
                key: 'createTime',
            },
            {
                title: '备注',
                dataIndex: 'mark',
                key: 'mark',
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record, index) => {
                    return this.renderAction(text, record, index);
                },
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        pagination={{
                            ...pagination,
                        }}
                        defaultExpandAllRows={false}
                        onChange={this.changeHandle}
                        rowSelection={rowSelection}
                    />
                    <Edit />
                    <AddAccountValue />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    selectedContent: state.appAccount.selectedContent,
    list: state.appAccount.list,
    pagination: state.appAccount.pagination,
    proxyrepeatinfo: state.appAccount.proxyrepeatinfo,
    uiStatus: state.appAccount.uiStatus,
    agentsGroup: state.appAccount.agentsGroup,
    transferData: state.appAccount.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    delUser: id => dispatch(actions.del(id)),
    delect: record => dispatch(delect(record)),
    delectAll: selectedRowsCurr1 => dispatch(delectAll(selectedRowsCurr1)),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    changePagination: data => dispatch(actions.changePagination(data)),
    getUserGroups: () => dispatch(getUserGroups()),
    getSele: data => dispatch(actions.getSele(data)),
    editShowValues: () => dispatch(actions.changeUiStatus({ isUpdateShowValue: true })),
});
export default connect(mapStateToProps, mapDispatchToProps)(AppAccount);



// WEBPACK FOOTER //
// ./pages/client/AppAccount/index.js